import {IconWrapperIconProps} from "app/Interface/Component/Icons"
import ModuleCompanyIcon from "app/WebView/Component/icons/moduleCompanyIcon"
import ModuleDashboardIcon from "app/WebView/Component/icons/moduleDashboardIcon"
import ModuleInvoiceIcon from "app/WebView/Component/icons/moduleInvoiceIcon"
import ModulePersonIcon from "app/WebView/Component/icons/modulePersonIcon"
import {ReactElement} from "react"

interface NavIcons {
  [key: string]: (props: IconWrapperIconProps) => ReactElement
}

export const ModuleIcons: NavIcons = {
  dashboard: ModuleDashboardIcon,
  company: ModuleCompanyIcon,
  person: ModulePersonIcon,
  invoice: ModuleInvoiceIcon
}
